import { FormLabel } from '@src/components/ui/FormLabel';
import { RadioButton } from '@src/components/ui/RadioButton';
import { useTheme } from '@src/components/ui/ThemeProvider';
import { isFormValidationError } from '@src/utilities/form';
import { ICommonFormProps } from '../DynamicForm.types';

export function FormRadioGroup(props: Readonly<ICommonFormProps>) {
    const { label } = props;
    const { theme } = useTheme();

    const onChange = (e: any) => {
        if (props.field) {
            const value = e?.target?.value ?? e?.currentTarget?.value;
            if (value !== undefined) {
                props.field.onChange(value);
            }
        }
    };

    return (
        <div className="flex flex-col gap-2.5">
            {label && (
                <FormLabel
                    label={label}
                    required={props.registerOptions?.required as boolean}
                />
            )}

            {props.formProps?.secondLabel && (
                <p className="text-primary text-base">
                    {props.formProps?.secondLabel}
                </p>
            )}

            <RadioButton
                name={props.keyName}
                options={props.formProps?.options ?? []}
                value={props.field?.value}
                onChange={onChange}
                disabled={props.disabled}
                className={props.className}
            />

            {props.errors && (
                <span
                    className="w-full font-normal text-xs text-left mt-1"
                    style={{ color: theme.colors.error.main.text }}
                >
                    {isFormValidationError(props.errors.type)
                        ? props.errors?.message
                        : `${props.label} ${props.errors.type}`}
                </span>
            )}
        </div>
    );
}
